import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelIssueTerminologyRefreshM4: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	label: {
		id: 'issue-table-inline-issue-create.inline-create-from.issue-type-dropdown.label',
		defaultMessage: 'Issue type',
		description: 'Label to be set on the issue type dropdown element',
	},
	labelIssueTerminologyRefreshM4: {
		id: 'issue-table-inline-issue-create.inline-create-from.issue-type-dropdown.label-issue-terminology-refresh-m4',
		defaultMessage: 'Work type',
		description: 'Label to be set on the issue type dropdown element',
	},
});
export default messages;
